<template>
  <div class="intro">
    <div class="left">
      <img src="@/assets/images/intro.png" alt="">
      <div class="content" v-html="introContent"></div>
      <router-link to="/company" tag="button">查看更多</router-link>
      <a href="javascript:void(0);">北京明世继元管理咨询（集团）有限公司</a>
    </div>
    <div class="right">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(banner,idx) in dynamicSlideList" :key="idx">
          <img :src="requestUrl + '/news/route/file/downloadfile/true/' + banner.newsContentCoverList" alt="">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import url from '@/assets/public/url'
export default {
  name: "Intro",
  components: {},
  props: {
    introContent: String,
    dynamicSlideList: Array
  },
  data() {
    return {
      requestUrl: url.url,
      swiperOptions: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 3000
      },
    }
  },
  methods: {},
  mounted() {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~styles/public.styl"
.intro
  margin 50px auto 0
  width 1200px
  overflow hidden
  .left
    float left
    width 600px
    img
      margin-bottom 35px
    .content >>>
      p
        line-height 25px
        font-size 14px
        color #333
        height 100px
        overflow hidden
        display -webkit-box
        -webkit-line-clamp 4
        -webkit-box-orient vertical
    button
      outline none
      width 120px
      height 30px
      border 2px solid $main-red
      color $main-red
      box-sizing border-box
      margin-top 50px
      background none
      cursor pointer
    a
      display inline-block
      height 30px
      line-height 30px
      color $main-red
      margin-left 20px
  .right
    float right
    width 590px
    img
      width 590px
      height 335px
</style>



// WEBPACK FOOTER //
// src/pages/Index/components/Intro.vue